<template>
  <div class="about">
    <div class="container">
        <h1>Login</h1>
        <label for="uname"><b>Username</b></label>
        <input type="text" placeholder="Enter Username" name="uname" v-model="userId" @keydown.enter="loginSubmit" required>
        <label for="psw"><b>Password</b></label>
        <input type="password" placeholder="Enter Password" name="psw" v-model="userPassword" @keydown.enter="loginSubmit" required>
        <p for="id_fail" v-bind:class="id_fail_msg"><b>❗{{id_fail_msg_text}}</b></p>
        <button type="submit" v-on:click="loginSubmit">Login</button>
    </div>
  </div>
</template>

<script>
  import '../assets/css/input.css';
  import '../assets/css/login.css';
  import axios from 'axios';
  import CryptoJS from 'crypto-js';
  export default {
    name: 'LoginView',
    
    data() {
      return {
        userId: null,
        userPassword: null,
        id_fail_msg: 'hidden fail_msg',
        id_fail_msg_text: 'Username이나 Password를 확인하세요.',
      };
    },
    methods: {
      changeFailMsg(msg){
        this.id_fail_msg_text = msg;
      },
      loginProcess(r) {
        console.log('Response data', r);
          if (r.data && r.data.auth !== undefined) {
            window.location.href = [0, 1].includes(r.data.auth) ? '/' : '/download';
          } else {
            this.id_fail_msg = 'fail_msg';
            console.log(this.id_fail_msg);
          }
        },
      loginSubmit() {
        let saveData = {};
        saveData.userId = this.userId;
        saveData.userPassword = CryptoJS.SHA256(this.userPassword).toString();
        // saveData.userPassword = this.userPassword;

        console.log('login', saveData);
        axios.post("/api/member/login", saveData, {
              header: {
                "Content-Type": "application/json",
              },
            })
          .then(res => {
            this.loginProcess(res);
          })
          .catch(err => {
            console.log('RESPONSE ERROR', err.message);
            if (err.code == 'ERR_BAD_RESPONSE'){
              console.log('server off.');
              window.location.href = `/maintenance`;
            } else if (err.code == 'ERR_UNAUTHORIZED') {
              console.log(err.message);
              this.changeFailMsg('Your IP is currently blocked. Please contact to MEDIIMG.');
            } else {
              this.id_fail_msg = 'fail_msg';
              console.log(this.id_fail_msg);
            }
          });
        },
        
      },
    };
</script>

<!-- <style>
  /* @import "../assets/input.css"; */
   
</style> -->